import React from 'react';

const ActivityHistoryColumns: React.FC = () => {
  return (
    <div className='screening-results-columns'>
      <div
        className='screening-table-placeholder-column'
        style={{ borderTopLeftRadius: 'var(--radius-xl, 12px)' }}
      ></div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Date</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Type</div>
        </div>
      </div>
      <div className='screening-table-title-column'>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>User</div>
        </div>
      </div>
      <div
        className='screening-table-title-column'
        style={{
          minWidth: '400px',
          flex: '3',
          borderTopRightRadius: 'var(--radius-xl, 12px)',
        }}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Activity</div>
        </div>
      </div>
    </div>
  );
};

export default ActivityHistoryColumns;
